import { AxiosResponse } from 'axios';
import { httpService } from 'shared/api';
import { IVoice } from '../model';

export const voiceApi = {
  fetchVoices: async () => {
    const { data }: AxiosResponse<IVoice[]> = await httpService.get(
      `/voices` + '/'
    );
    return data;
  }
};
